import { grey } from "@mui/material/colors";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    '@global': {
        '#root': {
            position: 'absolute',
            width: '100vw',
            height: '100vh',
            overflowX: 'hidden'
        },
        '*::-webkit-scrollbar': {
            //backgroundColor: '#fff',
            width: '3px'
        },
        '*::-webkit-scrollbar-track': {
            '-webkit-box-shadow': 'inset 0 0 1px #fff'
            //backgroundColor: '#fff',
        },
        '*::-webkit-scrollbar-thumb': {
            backgroundColor: '#babac0',
            borderRadius: '5px',
            outline: '1px solid #fff'
        },
        '*': {
            boxSizing: 'border-box',
            margin: 0,
            padding: 0,
        },
        '[class*=DatePicker_dateLabel__]': {
            fontSize: 14
        },
        '.react-calendar__tile--now': {
            backgroundColor: 'transparent'
        },
        '.react-calendar__tile--active': {
            backgroundColor: (props) => `${props.theme.palette.primary.main} !important`,
            fontWeight: 600,
            color: (props) => `${props.theme.palette.primary.contrastText} !important`,
            borderRadius: '100%'
        },
        '.react-calendar__tile--dayAvailable': {
            //backgroundColor: (props) => props.theme.palette.secondary.main,
            fontWeight: 600,
            //color: (props) => props.theme.palette.secondary.contrastText ,
            color: (props) => props.theme.palette.secondary.main,
            borderRadius: '100%'
        },
        '.react-calendar-horizontal-dayActive': {
            fontWeight: 600,
            backgroundColor: (props) => `${props.theme.palette.primary.main} !important`,
            color: (props) => `${props.theme.palette.primary.contrastText} !important`,
            borderRadius: '50%',
            width: '45px',
            height: '45px'
        },
        '.react-calendar-horizontal-dayAvailable': {
            fontWeight: 600,
            //backgroundColor: (props) => props.theme.palette.secondary.main,
            //color: (props) => props.theme.palette.primary.contrastText,
            color: (props) => props.theme.palette.secondary.main,
            borderRadius: '50%',
            width: '45px',
            height: '45px'
        },
        '.react-calendar-horizontal-dayDisabled': {
            pointerEvents: 'none'
        },
        html: {
            '-webkit-font-smoothing': 'antialiased',
            '-moz-osx-font-smoothing': 'grayscale',
            height: '100%',
            width: '100%'
        },
        body: {
            height: '100%',
            width: '100%'
        },
        a: {
            textDecoration: 'none'
        },
        '[class*=DatePicker_button__]': {
            background: "transparent !important",
            color: `${grey[500]} !important`,
        },
        '[class*=DatePicker_buttonWrapper__]': {
            height: "60px",
            marginTop: "20px",
        },
        '.react-calendar__tile:disabled': {
            backgroundColor: "transparent",
        }
    },
});

const StylesGlobal = (props) => {
    useStyles(props);

    return null;
};

export default StylesGlobal;
